import { createApp, defineAsyncComponent } from "vue";

import SvgVue from 'svg-vue3'
import VueLazyLoad from 'vue3-lazyload'

const app = createApp({
  components: {
    VideoBackground: defineAsyncComponent(() => import('./common/VideoBackground.vue')),
    SocialIcons: defineAsyncComponent(() => import('./common/SocialMediaIcons.vue')),
  },

  data: () => ({
    openMenu: '',
    scrollPosition: 0,
    alertsOpen: false,
    activeFaq: '',
    activeMobileNavGroup: 'about',
    isLeaving: '',
    lastEvent: undefined,
    remind_me: true,
    rememberedLinks: []
  }),

  computed: {
    mobileMenu () {
      return this.openMenu === 'mobileMenu'
    },
    searchBox () {
      return this.openMenu === 'searchBox'
    },
    isScrolling () {
      return this.scrollPosition > 0
    },
  },

  methods: {
    // toggleMenu (menu) {
    //   this.openMenu = (this.openMenu != menu ? menu : '')
    // },
    toggleMenu (menu = '') {
      if(this.openMenu != menu) {
        this.openMenu = menu
        this.$nextTick(() => {
          this.$refs[menu + '_modal'].focus()
        })
      } else {
        this.openMenu = ''
        this.$nextTick(() => {
          this.$refs[menu + '_button'].focus()
        })
      }
    },

    setMobileNavGroup (item) {
      this.activeMobileNavGroup = this.activeMobileNavGroup != item ? item : ''
    },

    handleScroll (event) {
      this.scrollPosition = window.pageYOffset != undefined ? window.pageYOffset : window.scrollY
    },

    toggleFaq(val){
      this.activeFaq = this.activeFaq == val ? '' : val
    },

    setSidebar (sidebar) {
      this.openSidebar = sidebar
    },

  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

})

app.use(VueLazyLoad, {
  loading: '',
  error: '',
  lifecycle: {
    loading: (el) => {
      // console.log('loading', el)
    },
    error: (el) => {
      // console.log('error', el)
    },
    loaded: (el) => {
      // console.log('loaded', el)
    }
  }
})

app.use(SvgVue, {
  svgPath: 'resources/svg',
  extract: false,
  svgoSettings: [
      { removeTitle: true },
      { removeViewBox: false },
      { removeDimensions: true }
  ]
})

app.mount("#app")
